import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    _id:"",
    usertype:"",
    firstname:"",
    lastname:"",
    gender:"",
    phonenumber:"",
    email:"",
    userlevel:"",
    isActive: "",
    establishments: "" ,

    

};

const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state._id = action.payload._id;
      state.usertype = action.payload.usertype;  
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.gender = action.payload.gender;
      state.phonenumber = action.payload.phonenumber;
      state.email = action.payload.email;
      state.userlevel = action.payload.userlevel;
      state.isActive = action.payload.isActive;   
      state.establishments = action.payload.establishments[0].name;

    },
    
  },
});

export const { setUser} = usersSlice.actions;
export default usersSlice.reducer;
